import React, { useEffect } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";

export default function MineActiveContestMessagesFiles() {
  const path = "Assets/scss/chat.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  return (
    <div className ="chat-message">
      <div className ="chatbox-first">
        <div className ="search-bar">
          <input
            type="search"
            placeholder="Search Files"
            className ="form-control"
          />
          <button className ="btn search-btn">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
              alt=""
            />
          </button>
        </div>
        <div className ="select-flex">
          <p>View:</p>
          <select className ="form-control">
            <option value="1">All Entries</option>
            <option value="1">All Entries</option>
            <option value="1">All Entries</option>
          </select>
        </div>
        <div className ="select-flex">
          <p>Sort by :</p>
          <select className ="form-control">
            <option value="1">Most rated</option>
            <option value="1">Most rated</option>
            <option value="1">All Entries</option>
          </select>
        </div>
      </div>
      <div className ="chatbox-second">
        <div className ="chatbox-row">
          <div className ="chatbox-content chat-left">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/comment-img.svg`}
              alt=""
            />
            <div className ="chat-carla ">
              <h6>Carla Carder</h6>
              <p>
                Euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
              </p>
              <span>10:24 am</span>
            </div>
          </div>
          <div className ="chatbox-content chat-right">
            <div className ="chat-carla ">
              <h6>You</h6>
              <p>
                Euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
              </p>
              <span>10:24 am</span>
            </div>
          </div>
        </div>
        <p className ="date">Tuesday, October 10</p>
        <div className ="chatbox-row">
          <div className ="chatbox-content chat-right">
            <div className ="chat-carla ">
              <h6>You</h6>
              <p>
                Euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
              </p>
              <img
                src={`${CloudStorage.cloudurl}//Assets/Images/expertregisteration/file-upload.png`}
                className =" w-100"
                alt="Certificate"
              />
              <span>10:24 am</span>
            </div>
          </div>
        </div>
      </div>
      <div className ="chatbox-footer">
        <div className ="chatbox-footer-first">
          <input
            type="text"
            className ="form-control"
            placeholder="Write here"
          />
          <button className ="btn smile">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/smile.svg`}
              alt=""
            />
          </button>
          <div className ="send-btn">
            <button className ="btn ">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/attachment.svg`}
                alt=""
              />
            </button>
            <button className ="btn ">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/send.svg`}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
